import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingSmsActions from "../actions/account_campaign_pricing_sms_actions";
import * as accountCampaignPricingSmsTypes from "../types/account_campaign_pricing_sms_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountSmsCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_SMS}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingSmsActions.getPricingOfAccountSmsCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingSmsActions.getPricingOfAccountSmsCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingSmsActions.getPricingOfAccountSmsCampaignError(e));
  }
}

function* editPricingOfAccountSmsCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_SMS}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingSmsActions.editPricingOfAccountSmsCampaignSuccess(res.data));
      yield put(accountCampaignPricingSmsActions.getPricingOfAccountSmsCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingSmsActions.editPricingOfAccountSmsCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingSmsActions.editPricingOfAccountSmsCampaignError(e));
  }
}

export default function* accountCampaignPricingSmsSaga() {
  yield takeLatest(accountCampaignPricingSmsTypes.getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST, getPricingOfAccountSmsCampaign);
  yield takeLatest(accountCampaignPricingSmsTypes.editPricingOfAccountSmsCampaign.EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST, editPricingOfAccountSmsCampaign);
}
